import React from "react";
import Footer from "@/components/Footer";
import NewHeader from "@/components/NewHeader";
import SpaHeroSection from "@/components/spa/SpaHeroSection";
import NatureAndScienceSection from "@/components/spa/NatureAndScienceSection";
import TreatmentsAndServicesSection from "@/components/spa/TreatmentsAndServicesSection";
import SpaBooking from "@/components/spa/SpaBooking";
import SpaFAQ from "@/components/spa/SpaFAQ";
import SEO from "@/components/SEO";
import { useLanguage } from "@/contexts/LanguageContext";
import { getPageSEO, SEOLanguage } from "@/data/seoTranslations";
import { getTranslatedStructuredData } from "@/data/structuredDataTranslations";
import { createBreadcrumbSchema } from "@/data/structuredData";

import { ServiceListTray } from "@/components/spa/ServiceListTray";
import SpaRenovationRibbon from "@/components/spa/SpaRenovationRibbon";

const Spa: React.FC = () => {
  const { language } = useLanguage();
  const seoLang = language as SEOLanguage;
  const seoData = getPageSEO("spa", seoLang);

  const breadcrumbSchema = createBreadcrumbSchema([
    { name: "Home", url: "https://beatenberg-resortspa.ch/" },
    { name: "Spa", url: "https://beatenberg-resortspa.ch/spa" },
  ]);

  return (
    <div className="min-h-screen bg-elegant-white relative" data-oid="f5cv.y9">
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical="/spa"
        language={seoLang}
        structuredData={[
          getTranslatedStructuredData.enhancedSpa(seoLang),
          getTranslatedStructuredData.spaFAQ(seoLang),
          breadcrumbSchema,
        ]}
        data-oid="w:m_vz0"
      />

      <NewHeader data-oid="gjh.10m" />
      <SpaHeroSection data-oid="dyumaw7" />

      <NatureAndScienceSection data-oid="okc8vad" />
      <TreatmentsAndServicesSection data-oid="treatments-services" />

      <SpaBooking data-oid="o04-6:g" />

      <SpaFAQ data-oid="8k6kj0k" />

      <Footer data-oid="v2rehiw" />

      <ServiceListTray />
      <SpaRenovationRibbon />
    </div>
  );
};

export default Spa;
